import _extends from "@babel/runtime/helpers/extends";
import { Box, Card, Divider, Text } from '@wix/design-system';
import React from 'react';
import { dataHooks } from '../../utils/datahooks';
export let OverviewSectionSkins = /*#__PURE__*/function (OverviewSectionSkins) {
  OverviewSectionSkins["warning"] = "warning";
  OverviewSectionSkins["neutral"] = "neutral";
  return OverviewSectionSkins;
}({});
export let OverviewSectionSizes = /*#__PURE__*/function (OverviewSectionSizes) {
  OverviewSectionSizes["small"] = "small";
  OverviewSectionSizes["medium"] = "medium";
  return OverviewSectionSizes;
}({});
const getNumbersTextSkin = overviewSectionSkins => {
  switch (overviewSectionSkins) {
    case OverviewSectionSkins.warning:
      {
        return 'error';
      }
    case OverviewSectionSkins.neutral:
    default:
      return 'standard';
  }
};
export const getBorderSkin = overviewSectionSkins => {
  switch (overviewSectionSkins) {
    case OverviewSectionSkins.warning:
      {
        return 'R50';
      }
    case OverviewSectionSkins.neutral:
    default:
      return 'D60';
  }
};
export const getTextInCircleSize = size => {
  switch (size) {
    case OverviewSectionSizes.small:
      {
        return 'small';
      }
    case OverviewSectionSizes.medium:
    default:
      return 'medium';
  }
};
export const getCircleRadius = size => {
  switch (size) {
    case OverviewSectionSizes.small:
      return '36px';
    case OverviewSectionSizes.medium:
    default:
      return '41px';
  }
};
const borderStyles = {
  border: '1px solid',
  borderColor: 'D60',
  borderRadius: '8px'
};
export const OverviewSection = _ref => {
  let {
    title,
    description,
    detectedIssues,
    skin = OverviewSectionSkins.neutral,
    dataHook,
    size = OverviewSectionSizes.medium,
    showShadow = true
  } = _ref;
  const issuesToShow = Number(detectedIssues) > 999 ? '+999' : detectedIssues;
  return /*#__PURE__*/React.createElement(Card, {
    showShadow: showShadow,
    stretchVertically: true
  }, /*#__PURE__*/React.createElement(Box, _extends({}, !showShadow && borderStyles, {
    dataHook: dataHooks.overviewSectionCardContainer(dataHook),
    padding: "12px"
  }), /*#__PURE__*/React.createElement(Box, {
    align: "center",
    alignSelf: "center",
    border: "2px solid",
    borderColor: getBorderSkin(skin),
    borderRadius: "30px",
    height: getCircleRadius(size),
    minWidth: getCircleRadius(size),
    verticalAlign: "middle",
    width: getCircleRadius(size)
  }, typeof issuesToShow === 'number' || typeof issuesToShow === 'string' ? /*#__PURE__*/React.createElement(Text, {
    dataHook: dataHooks.overviewSectionIssueNumberText(dataHook),
    size: getTextInCircleSize(size),
    skin: getNumbersTextSkin(skin),
    weight: "bold",
    dark: true,
    secondary: true
  }, issuesToShow) : issuesToShow), /*#__PURE__*/React.createElement(Box, {
    marginLeft: "SP2",
    marginRight: "SP2"
  }, /*#__PURE__*/React.createElement(Divider, {
    direction: "vertical"
  })), /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    verticalAlign: "middle"
  }, /*#__PURE__*/React.createElement(Text, {
    size: "small",
    weight: "bold"
  }, title), /*#__PURE__*/React.createElement(Text, {
    dataHook: "overview-section-description",
    secondary: true,
    size: "tiny",
    weight: "normal"
  }, description))));
};
//# sourceMappingURL=overview-section.js.map